module.exports = __webpack_public_path__ + "static/media/droetker-2x.f3eb0568.jpg";